import ActivityFire from './assets/activity-fire.svg';
import ActivityLines from './assets/activity-lines.svg';
import Apple from './assets/apple.svg';
import ArticleOutlined from './assets/article-outlined.svg';
import CareOutlined from './assets/care-outlined.svg';
import CarouselArrowLeft from './assets/carousel-arrow-left.svg';
import CarouselArrowRight from './assets/carousel-arrow-right.svg';
import CheckmarkUnfilled from './assets/checkmark-unfilled.svg';
import ChevronDown from './assets/chevron-down.svg';
import ChevronUp from './assets/chevron-up.svg';
import DaytimeStress from './assets/daytime-stress.svg';
import ExperimentOutlined from './assets/experiment-outlined.svg';
import Extensions from './assets/extensions.svg';
import ExternalLinkArrow from './assets/external-link-arrow.svg';
import FertileWindowGraph from './assets/fertile-window-graph.svg';
import GlucoseFilled from './assets/glucose-filled.svg';
import Glucose from './assets/glucose.svg';
import HeartFilled from './assets/heart-filled.svg';
import HeartHealth from './assets/heart-health.svg';
import HeartRangeKeyMetric from './assets/heart-range-key-metric.svg';
import Heart from './assets/heart.svg';
import Hrv from './assets/hrv.svg';
import InternalLinkArrowLeft from './assets/internal-link-arrow-left.svg';
import InternalLinkArrowRight from './assets/internal-link-arrow-right.svg';
import Labs from './assets/labs.svg';
import Language from './assets/language.svg';
import Lungs from './assets/lungs.svg';
import LutealUnconfirmedClock from './assets/luteal-unconfirmed-clock.svg';
import MarkerLocation from './assets/marker-location.svg';
import Minus from './assets/minus.svg';
import Moment from './assets/moment.svg';
import Moon from './assets/moon.svg';
import OpenInNewArrow from './assets/open-in-new-arrow.svg';
import PeriodPredictionStudy from './assets/period-prediction-study.svg';
import Plus from './assets/plus.svg';
import Profile from './assets/profile.svg';
import Repeat from './assets/repeat.svg';
import ResilienceFilled from './assets/resilience-filled.svg';
import RestMode from './assets/rest-mode.svg';
import SleepStages from './assets/sleep-stages.svg';
import SoundscapeBreathingBells from './assets/soundscape-breathing-bells.svg';
import SuprepWalkingEquivalencySteps from './assets/suprep-walking-equivalency-steps.svg';
import Temperature from './assets/temperature.svg';
import Trends from './assets/trends.svg';
import Walking from './assets/walking.svg';
import Waves from './assets/waves.svg';
import WomensHealth from './assets/womens-health.svg';
import X from './assets/x.svg';

export type IconNames =
  | 'activity-fire'
  | 'activity-lines'
  | 'apple'
  | 'article-outlined'
  | 'care-outlined'
  | 'carousel-arrow-left'
  | 'carousel-arrow-right'
  | 'checkmark-unfilled'
  | 'chevron-down'
  | 'chevron-up'
  | 'daytime-stress'
  | 'experiment-outlined'
  | 'extensions'
  | 'external-link-arrow'
  | 'fertile-window-graph'
  | 'glucose-filled'
  | 'glucose'
  | 'heart-filled'
  | 'heart-health'
  | 'heart-range-key-metric'
  | 'heart'
  | 'hrv'
  | 'internal-link-arrow-left'
  | 'internal-link-arrow-right'
  | 'labs'
  | 'language'
  | 'lungs'
  | 'luteal-unconfirmed-clock'
  | 'marker-location'
  | 'minus'
  | 'moment'
  | 'moon'
  | 'open-in-new-arrow'
  | 'period-prediction-study'
  | 'plus'
  | 'profile'
  | 'repeat'
  | 'resilience-filled'
  | 'rest-mode'
  | 'sleep-stages'
  | 'soundscape-breathing-bells'
  | 'suprep-walking-equivalency-steps'
  | 'temperature'
  | 'trends'
  | 'walking'
  | 'waves'
  | 'womens-health'
  | 'x';

const Icons = {
  'activity-fire': ActivityFire,
  'activity-lines': ActivityLines,
  apple: Apple,
  'article-outlined': ArticleOutlined,
  'care-outlined': CareOutlined,
  'carousel-arrow-left': CarouselArrowLeft,
  'carousel-arrow-right': CarouselArrowRight,
  'checkmark-unfilled': CheckmarkUnfilled,
  'chevron-down': ChevronDown,
  'chevron-up': ChevronUp,
  'daytime-stress': DaytimeStress,
  'experiment-outlined': ExperimentOutlined,
  extensions: Extensions,
  'external-link-arrow': ExternalLinkArrow,
  'fertile-window-graph': FertileWindowGraph,
  'glucose-filled': GlucoseFilled,
  glucose: Glucose,
  'heart-filled': HeartFilled,
  'heart-health': HeartHealth,
  'heart-range-key-metric': HeartRangeKeyMetric,
  heart: Heart,
  hrv: Hrv,
  'internal-link-arrow-left': InternalLinkArrowLeft,
  'internal-link-arrow-right': InternalLinkArrowRight,
  labs: Labs,
  language: Language,
  lungs: Lungs,
  'luteal-unconfirmed-clock': LutealUnconfirmedClock,
  'marker-location': MarkerLocation,
  minus: Minus,
  moment: Moment,
  moon: Moon,
  'open-in-new-arrow': OpenInNewArrow,
  'period-prediction-study': PeriodPredictionStudy,
  plus: Plus,
  profile: Profile,
  repeat: Repeat,
  'resilience-filled': ResilienceFilled,
  'rest-mode': RestMode,
  'sleep-stages': SleepStages,
  'soundscape-breathing-bells': SoundscapeBreathingBells,
  'suprep-walking-equivalency-steps': SuprepWalkingEquivalencySteps,
  temperature: Temperature,
  trends: Trends,
  walking: Walking,
  waves: Waves,
  'womens-health': WomensHealth,
  x: X,
};

export default Icons;
